import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    details: []
  },
  getters: {
    details: (state) => state.details,
  },
  actions: {
    rejectPurchaseInvoice({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Procurements/api/PurchaseInvoices/go-to-reject", id).then((r) => {
            resolve(r.data);
          })
      });
    },
    acceptPurchaseInvoice({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Procurements/api/PurchaseInvoices/go-to-confirm" , id)
          .then((r) => {
            // commit("setDetails", r.data);
            resolve(r.data);
          })
      });
    },
    updateShipmentInfo({ commit, dispatch } , model) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Procurements/api/PurchaseInvoices/update-shipment-info" , model)
          .then((r) => {
            // commit("setDetails", r.data);
            resolve(r.data);
          })
      });
    },
    saveItemCodeFunction({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Procurements/api/PurchaseInvoices/update-items-code", model).then((r) => {
            resolve(r.data);
          }).catch((e) => console.log(e));
      });
    },
    saveWeightFunction({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Procurements/api/PurchaseInvoices/update-weights-of-items", model).then((r) => {
            resolve(r.data);
          }).catch((e) => console.log(e));
      });
    },
    updateSellerInfo({ commit, dispatch } , model) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Procurements/api/PurchaseInvoices/update-seller-reference" , model)
          .then((r) => {
            // commit("setDetails", r.data);
            resolve(r.data);
          })
      });
    },
    fetchPurchaseInvoice({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Procurements/api/PurchaseInvoicesQuery/" + id)
          .then((r) => {
            // commit("setDetails", r.data);
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
    },
    fetchPurchaseOrderById({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Procurements/api/PurchaseOrdersQuery/count-of-remaining/" + id)
          .then((r) => {
            // commit("setDetails", r.data);
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
    },
    fetchSearchSupplier({ commit, dispatch }, name) {
        return new Promise((resolve, reject) => {
          ajax
            .get("Procurements/api/SuppliersQuery/" + name)
            .then(r => {
              resolve(r.data);
            })
            .catch(e => {
              reject(e);
            });
        });
      },
    closePurchaseInvoice({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Procurements/api/PurchaseInvoices/go-to-close", id).then((r) => {
            resolve(r.data);
          })
      });
    },
    savePurchaseInvoice({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .post("Procurements/api/PurchaseInvoices", model).then((r) => {
            resolve(r.data);
          })
      });
    },
    saveDeductionAndIncrease({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Procurements/api/PurchaseInvoices/update-deduction-and-increase", model).then((r) => {
            resolve(r.data);
          }).catch((e) => console.log(e));
      });
    },
    saveCurrencyType({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Procurements/api/PurchaseInvoices/update-currency-info", model).then((r) => {
            resolve(r.data);
          }).catch((e) => console.log(e));
      });
    },
    
  },
  mutations: {
    setDetails(state, data) {
      state.details = data;
    }
  }
};
